import React from 'react';
import {
  Box, FormControlLabel, FormHelperText, Radio, RadioGroup, Typography,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import { currencyFormat } from '../../constants';
import useApplication from '../../resources/applications/read';

const LoanPackageRadioGroup = ({ control }) => {
  const { data: application } = useApplication();
  const roadsideLoan = application.attributes.loan_options[0].ancillary_loans[0];
  const regularLoan = application.attributes.loan_options[0].regular_loans[0];

  return (
    <Controller
      name="loanPackageId"
      control={control}
      rules={{ required: 'You must select a loan package to proceed.' }}
      render={
        ({
          field,
          fieldState,
        }) => (
          <>
            <div>
              <RadioGroup
                id="loan-package"
                onBlur={field.onBlur}
                onChange={field.onChange}
                value={field.value}
                name={field.name}
              >
                { application.attributes['roadside_assistance_offered?'] && (
                  <Box sx={{
                    backgroundColor: '#F5F5F5',
                    padding: '10px 16px',
                    borderRadius: '8px',
                    display: 'flex',
                    mb: '8px',
                  }}
                  >
                    <FormControlLabel
                      control={<Radio sx={{ pt: 0 }} />}
                      value={roadsideLoan.id}
                      sx={{ flex: 1, margin: 0, alignItems: 'flex-start' }}
                      name="roadside"
                      label={(
                        <Box>
                          <Typography variant="subtitle2" align="left">
                            {currencyFormat.format(roadsideLoan.payment)}
                            {' '}
                            / month
                          </Typography>
                          <Typography variant="body2" align="left">
                            {roadsideLoan.term}
                            {' '}
                            months
                          </Typography>
                          <Typography variant="body2" align="left">
                            +
                            {' '}
                            {roadsideLoan.ancillary_term}
                            {' '}
                            month Roadside Assistance
                          </Typography>
                        </Box>
                      )}
                    />
                  </Box>
                )}
                <Box sx={{
                  backgroundColor: '#F5F5F5', padding: '10px 16px', borderRadius: '8px', display: 'flex',
                }}
                >
                  <FormControlLabel
                    control={<Radio sx={{ pt: 0 }} />}
                    value={regularLoan.id}
                    sx={{ flex: 1, margin: 0, alignItems: 'flex-start' }}
                    name="regular"
                    label={(
                      <Box>
                        <Typography variant="subtitle2" align="left">
                          {currencyFormat.format(regularLoan.payment)}
                          {' '}
                          / month
                        </Typography>
                        <Typography variant="body2" align="left">
                          {regularLoan.term}
                          {' '}
                          months
                        </Typography>
                      </Box>
                    )}
                  />
                </Box>
              </RadioGroup>
            </div>
            {fieldState.invalid && (
              <FormHelperText error>
                {fieldState.error.message}
              </FormHelperText>
            )}
          </>
        )
      }
    />
  );
};

export default LoanPackageRadioGroup;
